<script>
import searchResultsTabMixin from '@phoenix/mixins/searchResultsTabMixin';
import SearchResultsTab from '@maison/components/search/SearchResultsTab';
import { TAB_ARTICLES } from '@maison/helpers/search-helper';
import { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { algoliaTracking } from '@module/Algolia/resources/js/insights/helpers';
import SearchArticleCard from '@maison/components/search/SearchArticleCard.vue';

export default {
  components: {
    SearchArticleCard,
    SearchResultsTab,
  },

  mixins: [searchResultsTabMixin],

  props: {
    uniqueId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tab: TAB_ARTICLES,
    };
  },

  methods: {
    onArticleClick(article, position) {
      algoliaTracking(article, position, IndexNames.Articles);
    },
  },
};
</script>

<template>
  <search-results-tab :tab="tab" :limit="limit">
    <search-article-card
      v-for="(article, index) in items"
      :key="article.id"
      v-bind="article"
      :data-tracking="dataTracking"
      @click="onArticleClick(article, index)"
    />
  </search-results-tab>
</template>
